import React, { useMemo, useState } from 'react';
import { X } from 'lucide-react';
import CarrierLogo from '../../../../components/producerPage/CarrierLogo.jsx';
import { inputCls } from '../ui.jsx';
import { resolveCarriers } from '../../../../lib/producerPage.js';

const MAX = 25;

/** Step 5 (optional) — carriers to showcase; logos are pulled automatically. */
export default function CarriersStep({ ctx }) {
  const { page, patch, catalog } = ctx;
  const [q, setQ] = useState('');
  const chosen = useMemo(() => new Set(page.carriers), [page.carriers]);
  const list = useMemo(
    () => (catalog?.carriers || []).filter((c) => c.name.toLowerCase().includes(q.trim().toLowerCase())),
    [catalog, q],
  );
  const full = chosen.size >= MAX;
  const toggle = (id) => patch({ carriers: chosen.has(id) ? page.carriers.filter((c) => c !== id) : [...page.carriers, id] });
  const picked = resolveCarriers(page, catalog);

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold">Carriers <span className="text-sm font-normal text-white/50">(optional)</span></h3>
        <p className="text-xs text-white/60">Showcase the insurance companies you work with. Each company's logo is pulled in automatically. Choose up to {MAX}.</p>
      </div>

      {picked.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="pp-carrier-chips">
          {picked.map((c) => (
            <span key={c.id} className="inline-flex items-center gap-1 rounded-full bg-white/10 py-1 pl-3 pr-1.5 text-xs">
              {c.name}
              <button type="button" aria-label={`Remove ${c.name}`} onClick={() => toggle(c.id)} className="rounded-full p-0.5 hover:bg-white/10"><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}

      <input className={inputCls} placeholder="Search carriers" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Search carriers" />

      <div className="grid max-h-[420px] grid-cols-2 gap-2 overflow-y-auto pr-1 sm:grid-cols-3" role="group" aria-label="Carriers">
        {list.map((c) => {
          const on = chosen.has(c.id);
          return (
            <button
              key={c.id}
              type="button"
              aria-pressed={on}
              disabled={!on && full}
              onClick={() => toggle(c.id)}
              data-testid={`pp-carrier-${c.id}`}
              className={`flex flex-col items-center rounded-lg border p-2 transition disabled:opacity-40 ${on ? 'border-civix-purple bg-white' : 'border-white/10 bg-white/90 hover:border-civix-purple/50'}`}
            >
              <CarrierLogo carrier={c} size={36} />
            </button>
          );
        })}
        {list.length === 0 && <p className="col-span-full text-sm text-white/50">No carriers match “{q}”.</p>}
      </div>
    </div>
  );
}
